import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"

interface Args {
  course: Course
  planbook: Planbook
  rotationCalendar: RotationCalendar
  dateString: string
  useStudentVersion?: boolean
  useCardStackSummary?: boolean
}
export default class LessonProviderComponent extends Component<Args> {}
